// WEB-PHASE-1A-SOCKET — shadow-mode configuration helpers.
//
// Pure, dependency-free helpers that decide WHETHER and WHERE the Socket.IO
// client connects. Kept separate from React so the wiring (SocketProvider) and
// the policy (this file) can evolve independently and be reasoned about in
// isolation. Nothing here triggers any side effect on import.

// Feature flag. Values:
//   undefined / "off"  -> socket disabled entirely (default, current prod)
//   "shadow"           -> connect + log received events ONLY, no refetch
//   "on"               -> reserved for a LATER, separately-approved phase
// Read once from build-time env. Anything other than "shadow"/"on" is treated
// as disabled so a typo can never silently start live behavior.
export const SOCKET_MODE = (process.env.REACT_APP_SOCKET_REFRESH || "off")
  .trim()
  .toLowerCase();

export const isSocketEnabled = () =>
  SOCKET_MODE === "shadow" || SOCKET_MODE === "on";

export const isShadowMode = () => SOCKET_MODE === "shadow";

// Socket.IO server path (API Phase 1A): mounted under /api/socket.io.
export const SOCKET_PATH = "/api/socket.io";

// Derive the socket ORIGIN from the same env the REST client uses, so socket
// and API always point at one host. REACT_APP_APIENDPOINT looks like
// "https://offeryard.com/api/api/" -> origin "https://offeryard.com".
export const getSocketOrigin = () => {
  const endpoint = process.env.REACT_APP_APIENDPOINT || "";
  try {
    return new URL(endpoint).origin;
  } catch (e) {
    // Last-resort fallback; never throw during module/app init.
    return "https://offeryard.com";
  }
};

// Auth token used by the REST layer (x-auth-token-user). Same JWT the API
// Phase 1A socket expects via the handshake `auth.token`.
export const getAuthToken = () => {
  try {
    return localStorage.getItem("token-off") || "";
  } catch (e) {
    return "";
  }
};
